import axios from "axios";
import api from "../../../../../api/axios";

export const getInventory = () => api.get("pms/inventory");
export const addInventoryItem = (data) => api.post("pms/inventory", data);
export const updateStock = (inventoryId, payload) =>
  api.post(`pms/inventory-history`, {
    inventory_id: inventoryId,
    type: payload.adjustType,
    quantity: payload.qty,
    reason: payload.reason,
    expiry: payload.expiry,
  });
export const deleteInventoryItem = (id) => api.delete(`pms/inventory/${id}`);
export const getStockHistory = () => api.get("pms/inventory-history");
